// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1786":"69c69dc017173f2b","6418":"b6ea91348c721b29","7823":"b0caba73fd4fe5f2"}[chunkId] + ".js";
};